import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';

// Secondary navigation can be customize by the Admin in the BO
const useSecondaryNavigationTheme = ({ network } = {}) => {
  const { currentNetwork } = useDefaultAppContexts();

  const networkData = network || currentNetwork;

  return {
    backgroundColor:
      networkData?.theming?.fo?.fo_secondary_navigation_background_color,
    fontBrightness:
      networkData?.theming?.fo?.fo_secondary_navigation_font_brightness,
    themeName: 'fo',
  };
};

export default useSecondaryNavigationTheme;
